import { SpeedInsights } from "@vercel/speed-insights/react"
import { useEffect, useState } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
// import useLocalStorage from 'use-local-storage';
import Header from './components/header/Header';

import Loader from './components/loader/Loader';

import ScrollToTop from './components/ScrollToTop/scrollToTop';
import BgAnim from './components/animation/BgAnim';
import { useDataContext } from './Context/DataContext';
import { AnimationProvider } from './Context/AnimationContext';

function App() {
  // const [darkMode, setDarkMode] = useLocalStorage("Darshik's-DarkMode", true);
  const { darkMode, toggleDarkMode } = useDataContext();
  const [loading, setLoading] = useState(false);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);
  const [showBgAnim, setShowBgAnim] = useState(false); // New state to control BgAnim visibility
  const [navbarOpen, setNavbarOpen] = useState(false);

  // const toggleDarkMode = () => {
  //   setDarkMode(darkMode === "dark" ? "light" : "dark")
  // }

  const location = useLocation();

  // Function called by Loader when its animation is done
  const handleExitComplete = () => {
    // 💡 CRITICAL: Instantly hide the loader from the DOM
    setLoading(false);
  };

  useEffect(() => {
    // Reset states for a new page load
    setLoading(true);
    setIsAnimatingOut(false);
    // showBgAnim remains true
    setShowBgAnim(true)

    // Timer for the initial loading time (e.g., 2 seconds)
    const loadingTimer = setTimeout(() => {
      setIsAnimatingOut(true); // Start the shutter animation
    }, 500);

    return () => clearTimeout(loadingTimer);
  }, [location.pathname]);

  useEffect(() => {
    const handleOverflow = () => {
      if (navbarOpen && window.innerWidth <= 768) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    };

    handleOverflow();
    window.addEventListener("resize", handleOverflow);

    return () => {
      window.removeEventListener("resize", handleOverflow);
      document.body.style.overflow = "";
    };
  }, [navbarOpen]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setNavbarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <SpeedInsights />
      <AnimationProvider>
        {darkMode === "dark" ? '' :
          <Alert toggleDarkMode={toggleDarkMode} />
        }
        <div className={`${darkMode || "dark"} page-wrapper`} data-theme={`${darkMode || "dark"}`}>
          <div className='relative bg-slate-200 dark:bg-[#1e1e1e]'>
            <ScrollToTop />
            {showBgAnim && <BgAnim show={!loading} />} {/* Render BgAnim after delay */}
            {/* {loading ? (
              <Loader />
            ) : ( */}
            {/* 💡 Loader Overlay: Only rendered if isLoading is true */}
            {loading && (
              <div className='fixed inset-0 z-[100]'>
                <Loader
                  isExiting={isAnimatingOut}
                  onExitComplete={handleExitComplete}
                  darkMode={darkMode} // Pass darkMode to ensure correct background color
                />
              </div>
            )}
            <div className='pt-5'>
              <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} navbarOpen={navbarOpen} setNavbarOpen={setNavbarOpen} />
              <main className={`${navbarOpen ? 'blur-md pointer-events-none scale-[0.98]' : ''} transition-all duration-300`}>
                <Outlet />
              </main>
            </div>
            {/* )} */}
          </div>
        </div>
      </AnimationProvider>
    </>
  );
}

export default App;



export const Alert = ({ toggleDarkMode }) => {
  // Listen for Enter key to change to dark mode
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        toggleDarkMode();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [toggleDarkMode]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg max-w-sm text-center">
        <h2 className="text-lg font-bold mb-4 text-red-500">Other Mode is Under Maintenance</h2>
        <p className="mb-6 text-gray-700 dark:text-gray-300">
          Please switch to dark mode for a better experience.
        </p>
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          onClick={toggleDarkMode}
        >
          Switch to Dark Mode
        </button>
      </div>
    </div>
  )
}
